// extracted by mini-css-extract-plugin
export default {"wrap":"R-z","heading":"S-z","formError":"T-z"};